// extracted by mini-css-extract-plugin
export default {"container":"ManageOrders_container__yRWqm","heading":"ManageOrders_heading__Qx9nF","manageSection":"ManageOrders_manageSection__Sv4AB"};